"use strict";
/**
 * @file Created on 02/14/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ResourceLockType_1 = require("../enums/ResourceLockType");

var ResourceLockDTO_1 = require("../model/ResourceLockDTO");

var ResourceLockDTOConverter_1 = require("./ResourceLockDTOConverter");
/**
 * @author Jaroslav Sevcik
 */


var ResourceLockDTOConverterImpl =
/*#__PURE__*/
function (_ResourceLockDTOConve) {
  _inherits(ResourceLockDTOConverterImpl, _ResourceLockDTOConve);

  function ResourceLockDTOConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ResourceLockDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockDTOConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ResourceLockDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ResourceLockDTO_1.ResourceLockDTO(ResourceLockDTO_1.ResourceLockDTO.schema.users.valueOf(conversions.asObjectList(source, 'users', function (doc) {
        return _this2.userInfoConverter.toObject(doc, conversions);
      })), ResourceLockDTO_1.ResourceLockDTO.schema.resourceId.valueOf(source.resourceId), ResourceLockDTO_1.ResourceLockDTO.schema.resourceLockType.valueOf(conversions.asEnum(source.resourceLockType, ResourceLockType_1.ResourceLockType)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        users: conversions.asObjectArray(source, 'users', function (userInfo) {
          return _this3.userInfoConverter.toDocument(userInfo, conversions);
        }),
        resourceId: source.resourceId,
        resourceLockType: source.resourceLockType
      };
    }
  }]);

  return ResourceLockDTOConverterImpl;
}(ResourceLockDTOConverter_1.ResourceLockDTOConverter);

ResourceLockDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ResourceLockDTOConverterImpl);
exports.ResourceLockDTOConverterImpl = ResourceLockDTOConverterImpl;